module.exports = "<!--page-wrapper Start-->\n<div class=\"page-wrapper\">\n   <router-outlet></router-outlet>\n</div>\n<!--page-wrapper Ends-->"